import localPricesRegionNames from "@data/localPricesRegionNames";

import {RegionSlug} from "../store/types";

export type PriceRegion = {
  id: string;
  name: PriceRegionName;
};

export type PricingItem = {
  name: string;
  price: number;
  slug: string;
  typ: string;
};

export type PriceRegionWithPrice = PriceRegion & {
  prices: PricingItem[];
};

export type PriceRegionName = (typeof localPricesRegionNames)[number];

// Pair Price Region Name with Clinic Region Slug
export const regionsByPricingRegionName: Record<PriceRegionName, RegionSlug[]> = {
  "Northern California": ["sf-bay-area", "sacramento"],
  "Southern California": [
    "los-angeles",
    "greater-san-diego",
    "orange-county",
    "san-luis-obispo",
    "inland-empire",
  ],
  Massachusetts: ["massachusetts"],
  Virginia: [],
  Ohio: ["ohio"],
  Colorado: ["colorado"],
  Oregon: ["oregon"],
  Washington: ["washington"],
  "New York": ["new-york"],
  Kansas: ["kansas"],
  Florida: ["florida"],
  Pennsylvania: ["pennsylvania"],
  "Central Jersey Urgent Care": ["new-jersey"],
  Nevada: ["nevada"],
  Arizona: [],
  Texas: ["texas"],
  Alabama: [],
  "Urgent Care of Colorado": [],
  "Coast Line Urgent Care": [],
  "Urgent Care MDs": [],
  Missouri: [],
  Minnesota: [],
  "Southern Arizona Urgent Care": ["arizona"],
  Ritecare: [],
};
